module.exports = __webpack_public_path__ + "assets/images/render-txt-detaility-mobile.3073c3f9470aa855b03693f092dbd954.svg";